import { SBTranslate } from "i18n";
import { ISupplyOrder } from "domain/Inventory/Models/ISupplyOrder";
import { ISupplyOrderSummary } from "domain/Inventory/Models/ISupplyOrderSummary";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SBSummarization from "views/Commons/SBSummarization";
import { ISupplyOrderSummarizationProps } from "./models/ISupplyOrderSummarizationProps";

export const SupplyOrderSummarization = ({
	summary,
	selectedItems,
}: ISupplyOrderSummarizationProps) => {
	const { i18n } = useTranslation();

	const sum = (list: ISupplyOrder[], field: keyof ISupplyOrder) =>
		list.reduce((acc, item) => acc + ((item[field] as number) || 0), 0);

	const hasSelected = !!selectedItems && selectedItems.length > 0;

	const summarizations = useMemo(
		() => [
			{
				name: SBTranslate("quantity"),
				tip: SBTranslate("quantity"),
				icon: "package",
				color: "darkPurple",
				value: summary?.totalQuantity ?? 0,
				selectedItems: hasSelected
					? sum(selectedItems!, "quantity")
					: undefined,
			},
			{
				name: SBTranslate("cost"),
				tip: SBTranslate("cost"),
				icon: "dollar-sign",
				color: "darkPurple",
				value: summary?.totalCost ?? 0,
				selectedItems: hasSelected
					? sum(selectedItems!, "cost")
					: undefined,
			},
		],
		[summary, selectedItems, i18n.language],
	);

	if (!summary || summary.totalCount === 0) return null;

	return <SBSummarization items={summarizations} withShadow />;
};
